/* eslint-disable react/destructuring-assignment */
import React, { useState, useContext } from "react";
import { string, bool, func } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import GridTable from "pages/_components/GridTable/GridTable";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import EcheqHeaderTicket from "pages/echeck/components/EcheqHeaderTicket";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import CustomData from "../../../_components/CustomData/CustomData";
import ProductList from "pages/_components/product/List";
import EndorseItem from "./ItemRow";
import TitleColumns from "./TitleColumns";

const TransactionBody = (props) => {
    const { transaction } = useContext(TransactionContext);
    const { showMoreData, setShowMoreData, isDesktop } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const { data: echeckAction = {}, idTransaction = "", idTransactionStatus } = transaction;
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const { document = props.document, echeqList = props.echeqList } = echeckAction;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const echeq = echeqList[0];

    return (
        <>
            <div className="ticket__body ticket__full-width">
                <EcheqHeaderTicket
                    estado={echeq.finalStatus || echeq.estado}
                    // caracter={echeq.cheque_caracter}
                    moneda={echeq.moneda}
                    monto={echeq.monto}
                    id={echeq.cheque_numero}
                    status={idTransactionStatus}
                    isDesktop={isDesktop}
                />
            </div>

            <div className="ticket__body ticket__full-width">
                <div className="view-more-data-button">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
            </div>

            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                <div className="ticket__body ticket__full-width">
                    <GridTable>
                        <GridTable.Container className="ticket-gap">
                            <GridTable.Data columnStart={1} rowStart={1}>
                                <CustomData
                                    titleText="echecks.beneficiary"
                                    titleTextType="I18N"
                                    valueText={echeq.tenencia_beneficiario_nombre}
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={1} rowStart={2} alignY="flex-start">
                                <CustomData
                                    titleText="echecks.emit.referencevalue.label"
                                    titleTextType="I18N"
                                    valueText={echeq.cheque_motivo_pago}
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={1} rowStart={3} alignY="flex-start">
                                <CustomData
                                    titleText="echecks.echeckReference"
                                    titleTextType="I18N"
                                    valueText={echeq.cheque_motivo_pago}
                                />
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={4} alignY="flex-start">
                                <CustomData
                                    titleText="echeq.accept.return.solicitor.name"
                                    titleTextType="I18N"
                                    valueText={echeckAction?.nombreSolicitante}
                                />
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={5} alignY="flex-start">
                                <CustomData
                                    titleText="echecks.payedRange.label"
                                    titleTextType="I18N"
                                    valueText={echeq?.fecha_pago}
                                    valueTextType="DATE"
                                />
                            </GridTable.Data>

                            <GridTable.Data columnStart={2} rowStart={1}>
                                <CustomData
                                    titleText="echecks.amount"
                                    titleTextType="I18N"
                                    valueText={echeq.monto}
                                    valueTextType={echeq.emisor_moneda}
                                />{" "}
                            </GridTable.Data>

                            <GridTable.Data columnStart={2} rowStart={2} alignY="flex-start">
                                <CustomData
                                    titleText="echecks.document"
                                    titleTextType="I18N"
                                    valueText={`${echeq.tenencia_beneficiario_documento_tipo} ${echeq.tenencia_beneficiario_documento}`}
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={3}>
                                <CustomData
                                    titleText="echecks.currency"
                                    titleTextType="I18N"
                                    valueText={echeq?.moneda}
                                />
                            </GridTable.Data>

                            <GridTable.Data columnStart={2} rowStart={4} alignY="flex-start">
                                <CustomData
                                    titleText="echeq.accept.return.solicitor.document"
                                    titleTextType="I18N"
                                    valueText={echeckAction?.cuilSolicitante}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable>
                    {/* </div>{" "} */}
                    {echeq?.endosos.length > 0 && (
                        <>
                            <div className="ticket__divider inside-ticket__body">
                                <div className="ticket__notch ticket__notch--left"> </div>
                                <div className="ticket__notch ticket__notch--right"> </div>
                            </div>
                            <ProductList
                                fetchingWithPreviousData
                                fetching={false}
                                items={echeq?.endosos || []}
                                noDataText="global.no.results"
                                noFiltersDataText="global.no.results"
                                renderItem={(item) => (
                                    <GridTable.Container key={item.fechaPago} renderAs="div">
                                        <EndorseItem item={item} isDesktop={isDesktop} isTicket />
                                    </GridTable.Container>
                                )}>
                                {(listItem) => (
                                    <GridTable className="detail-discounts-table tablelist">
                                        <GridTable.Header>
                                            <GridTable.Container>
                                                <TitleColumns isTicket />{" "}
                                            </GridTable.Container>
                                        </GridTable.Header>
                                        <GridTable.Body>{listItem}</GridTable.Body>
                                    </GridTable>
                                )}
                            </ProductList>
                        </>
                    )}
                </div>

                <div className="ticket__body ticket__full-width">
                    <TransactionSign
                        isSmall
                        creationTime
                        hasVaucher
                        isDesktop={isDesktop}
                        noDate={isPending}
                        showMoreData={showMoreData}
                    />
                </div>
            </div>
        </>
    );
};

TransactionBody.propTypes = {
    isDesktop: bool,
    showMoreData: bool,
    setShowMoreData: func,
    document: string,
};

TransactionBody.defaultProps = {
    isDesktop: false,
    showMoreData: false,
    setShowMoreData: () => {},
    document: "",
};

export default TransactionBody;
